/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q6Inputs */

const en_sorter_faq_q6 = /** @type {(inputs: Sorter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are my numeric keys not following the sort direction?`)
};

const ko_sorter_faq_q6 = /** @type {(inputs: Sorter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자 키가 왜 정렬 방향을 따르지 않나요?`)
};

const ja_sorter_faq_q6 = /** @type {(inputs: Sorter_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値キーがなぜ並べ替えの方向に従わないのですか`)
};

/**
* | output |
* | --- |
* | "Why are my numeric keys not following the sort direction?" |
*
* @param {Sorter_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q6 = /** @type {((inputs?: Sorter_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q6(inputs)
	if (locale === "ko") return ko_sorter_faq_q6(inputs)
	return ja_sorter_faq_q6(inputs)
});